// removed by extract-text-webpack-plugin
module.exports = {"NavigationItems":"_yd_dZzBcrRT8NyTlYD_N","Back":"_2nCfKIEbOPUBuQzWQ92Lg2"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Navigation/NavigationItems/NavigationItems.css
// module id = 415
// module chunks = 0